import { useState } from "react";
import { IconType } from "react-icons";
import { HiOutlineQuestionMarkCircle, HiX } from "react-icons/hi";

import { tw } from "utils/tw";

import { ActionID, Link } from "../basic";

export type NoticeID =
  | "checkmore-initialPopup"
  | "checkmore-movedTableToPeoplePopup"
  | "signmore-movedTableToPeoplePopup"
  | "accountSettings-headerNotice"
  | "indAccountSettings_accountInfo-headerNotice"
  | "indAccountSettings_authSettings-headerNotice"
  | "orgAccountSettings_team-headerNotice"
  | "orgAccountSettings_orgInfo-headerNotice"
  | "orgAccountSettings_paymentPlan-headerNotice"
  | "orgAccountSettings_policyDocuments-headerNotice"
  | "orgAccountSettings_subscriptions-headerNotice"
  | "payoutService-headerNotice"
  | "checkTypeSelection-headerNotice"
  | "receivedChecks-headerNotice"
  | "eSignatures-headerNotice"
  | "purchases-headerNotice"
  | "job-headerNotice"
  | "jobs-headerNotice"
  | "people-headerNotice"
  | "personChecks-headerNotice"
  | "personDocuments-headerNotice"
  | "sentChecks-headerNotice"
  | "people-headerNotice"
  | "person-headerNotice"
  | "wbReports-headerNotice"
  | "wbDirectory-headerNotice";

interface Props {
  heading: string;
  notice: {
    id: NoticeID;
    heading: string;
    body: string;
    readMoreLink?: {
      id: ActionID;
      label: string;
      url: string;
    };
  };
  LeadingIcon?: IconType;
}

export default ({ heading, notice, LeadingIcon }: Props): React.JSX.Element => {
  const [isShown, setIsShown] = useState(false);

  return (
    <div className={tw("flex", "flex-col", "space-y-2", "max-w-lg", "w-full")}>
      <div className={tw("flex", "items-center")}>
        {LeadingIcon && (
          <LeadingIcon
            size={24}
            className={tw("shrink-0", "mr-2", "text-deepBlue-900")}
          />
        )}

        <h1 className={tw("text-2xl", "font-extrabold", "text-deepBlue-900")}>
          {heading}
        </h1>

        <button onClick={() => setIsShown(!isShown)}>
          <HiOutlineQuestionMarkCircle
            size={24}
            className={tw("text-gray-400", "shrink-0", "ml-4")}
          />
        </button>
      </div>

      {isShown && (
        <div
          className={tw(
            "rounded-md",
            "bg-blue-100",
            "p-4",
            "flex",
            "flex-col",
            "space-y-1"
          )}
        >
          <div className={tw("flex", "justify-between")}>
            <h2
              className={tw(
                "font-bold",
                "text-deepBlue-900",
                "whitespace-pre-wrap"
              )}
            >
              {notice.heading}
            </h2>

            <button onClick={() => setIsShown(false)}>
              <HiX size={20} className={tw("text-deepBlue-900", "shrink-0")} />
            </button>
          </div>

          <p className={tw("text-deepBlue-900", "whitespace-pre-wrap")}>
            {notice.body}
            {notice.readMoreLink && (
              <>
                {" "}
                <Link id={notice.readMoreLink.id} to={notice.readMoreLink.url}>
                  {notice.readMoreLink.label}
                </Link>
              </>
            )}
          </p>
        </div>
      )}
    </div>
  );
};
